/**
 *
 * Asynchronously loads the component for Mobile Module
 *
 */

import loadable from "core/components/loadable";

export default loadable(() => import("./index"));
